import { useEffect, useState } from 'react'
import { getLocalApiUrl, authFetch } from '../config/api'

/**
 * Tenant setting: show the ECDD "Screening sources" OSINT tool button.
 * Returns { toolEnabled, loading } — toolEnabled is null until the first fetch completes.
 */
export function usePatronScreeningToolEnabled() {
  const [toolEnabled, setToolEnabled] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await authFetch(getLocalApiUrl('/api/patron-screening/settings'))
        const json = await res.json().catch(() => ({}))
        if (!cancelled && json?.success) {
          setToolEnabled(json.toolEnabled === true)
        } else if (!cancelled) {
          setToolEnabled(false)
        }
      } catch {
        if (!cancelled) setToolEnabled(false)
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  return { toolEnabled, loading }
}
